import { render, staticRenderFns } from "./Func134.vue?vue&type=template&id=137dc21a&scoped=true"
import script from "./Func134.vue?vue&type=script&lang=js"
export * from "./Func134.vue?vue&type=script&lang=js"
import style0 from "./Func134.vue?vue&type=style&index=0&id=137dc21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137dc21a",
  null
  
)

export default component.exports